import factChecking from 'app/entities/fact-checking/fact-checking.reducer';
import userExtra from 'app/entities/user-extra/user-extra.reducer';
import foreignerResidence from 'app/entities/foreigner-residence/foreigner-residence.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const entitiesReducers = {
  factChecking,
  userExtra,
  foreignerResidence,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
};

export default entitiesReducers;
